export default {
  naturalId: null,
  data: {
    title: null,
    content: null,
    imgUrl: null,
    wikiUrl: null,
  },
};
